import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createElement as _createElement } from "@emotion/react";
import { forwardRef } from 'react';
import { ReactSlider } from '../../primitives/Slider/components/ReactSlider.js';
import { Thumb } from '../../primitives/Slider/components/Thumb.js';
import { Track } from '../../primitives/Slider/components/Track.js';
export const Slider = /*#__PURE__*/_styled(forwardRef(({
  value,
  defaultValue,
  inverted,
  disabled = false,
  onSlide,
  onChange,
  ...restProps
}, ref) => {
  const isRangeSlider = Array.isArray(value) || Array.isArray(defaultValue);
  const renderTrack = ({
    key,
    ...restProps
  }, state) => _createElement(Track, {
    ...restProps,
    key: key,
    highlighted: state.index === (isRangeSlider ? 1 : 0),
    disabled: disabled
  });
  const renderThumb = ({
    key,
    ...restProps
  }) => _createElement(Thumb, {
    ...restProps,
    key: key,
    disabled: disabled,
    "data-testid": "thumb"
  });
  return _jsx(ReactSlider, {
    ...restProps,
    // @ts-expect-error FIXME
    ref: ref,
    value: value,
    defaultValue: defaultValue,
    invert: inverted,
    disabled: disabled,
    renderTrack: renderTrack,
    renderThumb: renderThumb,
    onChange: onSlide,
    onAfterChange: onChange
  });
}), process.env.NODE_ENV === "production" ? {
  target: "e1n8gdut0"
} : {
  target: "e1n8gdut0",
  label: "Slider"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNsaWRlci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFjSSIsImZpbGUiOiJTbGlkZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBqc3ggYXMgX2pzeCB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdC9qc3gtcnVudGltZVwiO1xuaW1wb3J0IHsgY3JlYXRlRWxlbWVudCBhcyBfY3JlYXRlRWxlbWVudCB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdFwiO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgZm9yd2FyZFJlZiB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IFJlYWN0U2xpZGVyIH0gZnJvbSAnLi4vLi4vcHJpbWl0aXZlcy9TbGlkZXIvY29tcG9uZW50cy9SZWFjdFNsaWRlci5qcyc7XG5pbXBvcnQgeyBUaHVtYiB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvU2xpZGVyL2NvbXBvbmVudHMvVGh1bWIuanMnO1xuaW1wb3J0IHsgVHJhY2sgfSBmcm9tICcuLi8uLi9wcmltaXRpdmVzL1NsaWRlci9jb21wb25lbnRzL1RyYWNrLmpzJztcbmV4cG9ydCBjb25zdCBTbGlkZXIgPSBzdHlsZWQoZm9yd2FyZFJlZigoeyB2YWx1ZSwgZGVmYXVsdFZhbHVlLCBpbnZlcnRlZCwgZGlzYWJsZWQgPSBmYWxzZSwgb25TbGlkZSwgb25DaGFuZ2UsIC4uLnJlc3RQcm9wcyB9LCByZWYpID0+IHtcbiAgICBjb25zdCBpc1JhbmdlU2xpZGVyID0gQXJyYXkuaXNBcnJheSh2YWx1ZSkgfHwgQXJyYXkuaXNBcnJheShkZWZhdWx0VmFsdWUpO1xuICAgIGNvbnN0IHJlbmRlclRyYWNrID0gKHsga2V5LCAuLi5yZXN0UHJvcHMgfSwgc3RhdGUpID0+IChfY3JlYXRlRWxlbWVudChUcmFjaywgeyAuLi5yZXN0UHJvcHMsIGtleToga2V5LCBoaWdobGlnaHRlZDogc3RhdGUuaW5kZXggPT09IChpc1JhbmdlU2xpZGVyID8gMSA6IDApLCBkaXNhYmxlZDogZGlzYWJsZWQgfSkpO1xuICAgIGNvbnN0IHJlbmRlclRodW1iID0gKHsga2V5LCAuLi5yZXN0UHJvcHMgfSkgPT4gKF9jcmVhdGVFbGVtZW50KFRodW1iLCB7IC4uLnJlc3RQcm9wcywga2V5OiBrZXksIGRpc2FibGVkOiBkaXNhYmxlZCwgXCJkYXRhLXRlc3RpZFwiOiBcInRodW1iXCIgfSkpO1xuICAgIHJldHVybiAoX2pzeChSZWFjdFNsaWRlciwgeyAuLi5yZXN0UHJvcHMsIFxuICAgICAgICAvLyBAdHMtZXhwZWN0LWVycm9yIEZJWE1FXG4gICAgICAgIHJlZjogcmVmLCB2YWx1ZTogdmFsdWUsIGRlZmF1bHRWYWx1ZTogZGVmYXVsdFZhbHVlLCBpbnZlcnQ6IGludmVydGVkLCBkaXNhYmxlZDogZGlzYWJsZWQsIHJlbmRlclRyYWNrOiByZW5kZXJUcmFjaywgcmVuZGVyVGh1bWI6IHJlbmRlclRodW1iLCBvbkNoYW5nZTogb25TbGlkZSwgb25BZnRlckNoYW5nZTogb25DaGFuZ2UgfSkpO1xufSkpIGBgO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9U2xpZGVyLmpzLm1hcCJdfQ== */");